var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "call-to-action grid grid__base", class: _vm.rootClasses },
    [
      _c("div", { staticClass: "call-to-action--container grid--container" }, [
        _c("div", { staticClass: "call-to-action--row grid--row" }, [
          _c(
            "div",
            {
              staticClass:
                "call-to-action--col call-to-action--col__content grid--col"
            },
            [
              _c(
                "div",
                { staticClass: "call-to-action--content" },
                [
                  _c("h1", { staticClass: "call-to-action--title u-reset" }, [
                    _vm._v(_vm._s(_vm.title))
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "call-to-action--text" }, [
                    _vm._v(_vm._s(_vm.lead))
                  ]),
                  _vm._v(" "),
                  _c(
                    "conditional-link",
                    _vm._b(
                      { staticClass: "btn btn__primary btn__medium" },
                      "conditional-link",
                      _vm.link,
                      false
                    )
                  )
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "call-to-action--col call-to-action--col__image grid--col"
            },
            [
              _c(
                "base-image",
                _vm._b(
                  {
                    staticClass: "call-to-action--image",
                    attrs: { "is-background": true }
                  },
                  "base-image",
                  _vm.image,
                  false
                )
              )
            ],
            1
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-10260b10", { render: render, staticRenderFns: staticRenderFns })
  }
}